<script lang="ts">
    import type Monster from "../../lib/monster";
    import SVG from './SVG.svelte';
    export let monster: Monster;

    let x: number = 0;
    let y: number = 0;
</script>

<div class='svg-container' bind:clientHeight={y} bind:clientWidth={x}>
    <SVG dimensions={Math.max(0, Math.min(x, y))} monster={monster}/>
</div>

<style>
    .svg-container {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
